import React from "react";
import PropTypes from "prop-types";
import Spinner from "@xo-union/tk-component-spinner";
import classesPropType from "@xo-union/classes-prop-type";
import { useButtonClasses } from "../ThemeContext.js";
var LoadingContainer = function LoadingContainer(_ref) {
  var classesProp = _ref.classes,
    loadingText = _ref.loadingText;
  var classes = useButtonClasses(classesProp);
  return /*#__PURE__*/React.createElement("div", {
    className: classes['loading-container']
  }, /*#__PURE__*/React.createElement(Spinner, {
    className: classes['loading-spinner'],
    size: "sm"
  }), loadingText);
};
process.env.NODE_ENV !== "production" ? LoadingContainer.propTypes = {
  /**
   * Class dependencies
   */
  classes: classesPropType(['loading-container', 'loading-spinner']),
  /**
   * Text to display during the `isLoading` state
   */
  loadingText: PropTypes.string
} : void 0;
export default LoadingContainer;